import { SHOW_LIFE_PAGE_SUB_NAVIGATION_MENU, LifeSubNavMenuActionType } from '../actions/lifePageSubNavigationActions';

interface LifePageSubNavMenuState {
    isOpen: boolean;
}

const initialState: LifePageSubNavMenuState = {
    isOpen: false
};

export function lifeSubNavMenu(state = initialState, action: LifeSubNavMenuActionType): LifePageSubNavMenuState
{
    switch (action.type)
    {
        case SHOW_LIFE_PAGE_SUB_NAVIGATION_MENU:
        {
            return {
                ...state,
                isOpen: action.payload
            };
        }
        default: 
        {
            return state;
        }
    }
}
